import ProductCard from 'app/javascript/components/store/ProductCard';
import type { StoreCategory, StoreProduct } from 'app/javascript/data/storeCatalogs';

interface StoreCategorySectionProps {
  id: StoreCategory;
  label: string;
  products: StoreProduct[];
  academyName: string;
  companySlug: string;
}

export default function StoreCategorySection({
  id,
  label,
  products,
  academyName,
  companySlug,
}: StoreCategorySectionProps) {
  return (
    <section id={id} className="scroll-mt-32">
      <div className="mb-6 flex items-baseline justify-between gap-4">
        <h2 className="font-bebas text-3xl uppercase tracking-[0.04em] text-foreground sm:text-4xl">{label}</h2>
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">
          {products.length} {products.length === 1 ? 'item' : 'itens'}
        </span>
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            academyName={academyName}
            companySlug={companySlug}
          />
        ))}
      </div>
    </section>
  );
}
